<template>
  <div class="meal-reminder">
    <contentHeader
      @checkSwitch="checkSwitch"
      :is-default-checked="isDefaultChecked"
      header-type="5"
    ></contentHeader>
    <div class="content">
      <template v-for="item in previewList">
        <previewModule
          :key="item.id"
          :data="item"
          :class="[selectedId == item.id ? 'selected' : '', 'disable']"
          :is-elm-special="transmitData.isElmSpecial"
          @showPreviewDia="showPreviewDia"
          type="2"
        ></previewModule>
      </template>
    </div>
    <!-- size-status="1" -->
    <previewDialog
      :transmit-data="transmitData"
      :data-list="dataList"
      :selected-id="selectedId"
      @selectedOk="selectedOk"
      @closePreviewDia="closePreviewDia"
      size-status="99"
    ></previewDialog>
    <toast v-if="isShowToast" :set-status="setStatus"></toast>
  </div>
</template>

<script>
import contentHeader from "@/components/header/header";
import previewModule from "@/components/preview/preview";
import previewDialog from "@/components/dialog/dialog";
import toast from "@/components/toast/toast";
import { mealMixin } from "@/mixins/mixins";
import { initPagePost, setModulePost } from "@/api/mealreminder";

export default {
  mixins: [mealMixin],
  components: {
    contentHeader,
    previewModule,
    previewDialog,
    toast,
  },
  data() {
    return {
      selectedId: null, // 默认选中模块的id
      transmitData: {
        // 传给弹窗的数据
        previewId: null, // 点击预览的id
        showPreview: false, // 显示预览弹窗
        imgNum: null, // 弹窗的图片的数量
        isElmSpecial: 0,
      },
      isDefaultChecked: null, // 控制是否开启开关
      setStatus: null, // 设置模板失败或者成功
      isShowToast: false,
    };
  },
  methods: {
    async initPage() {
      const { status, data } = await initPagePost();
      if (status == 1) {
        this.isDefaultChecked = false,// data.switch;
        this.selectedId = data.config.id;
        this.transmitData.isElmSpecial = data.is_elm_special;
      }
    },
    showPreviewDia(data) {
      this.transmitData = Object.assign(this.transmitData, data);
    },
    closePreviewDia(val) {
      this.transmitData.showPreview = val;
    },
    async selectedOk(dataObj) {
      let ajaxData = {
        switch: this.isDefaultChecked,
      };
      if (dataObj && dataObj.id) {
        ajaxData = { config_id: dataObj.id, switch: 1 };
      }
      const { status } = await setModulePost(ajaxData);
      if (status == 1) {
        if (!dataObj || !dataObj.id) return;
        this.selectedId = dataObj.id;
        this.setStatus = 1;
        this.isDefaultChecked = 1;
      } else {
        this.setStatus = 0;
      }
      this.isShowToast = true;
      setTimeout(() => {
        this.isShowToast = false;
      }, 2000);
    },
    checkSwitch(val) {
      this.isDefaultChecked = false; // val;
      //this.selectedOk();
    },
  },
  created() {
    this.initPage();
  },
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex-wrap: wrap;
  width: 1080px;

  /deep/ .preview {
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
